<template>
  <div
    class="doc-paper preview english-resume"
    :id="idPrefix + 'preview-page-02'"
    style="
      width: 210mm;
      height: auto;
      min-height: 0;
      padding: 15mm 18mm;
      box-sizing: border-box;
      font-family: 'Helvetica Neue', Arial, 'Hiragino Sans', sans-serif;
      color: #222;
      font-size: 10.5pt;
      line-height: 1.45;
      background: #fff;
      margin-top: 20px;
      break-before: page;
    "
  >
    <div style="width: 100%">
      <!-- 簡易ヘッダー -->
      <header
        style="
          display: flex;
          align-items: baseline;
          justify-content: space-between;
          width: 100%;
          margin-bottom: 20px;
          border-bottom: 1px solid #ccc;
          padding-bottom: 6px;
        "
      >
        <h1
          style="
            font-size: 14pt;
            font-weight: 700;
            color: #222;
            margin: 0;
            letter-spacing: 0.5px;
          "
        >
          {{ fullName }}
        </h1>
        <span style="font-size: 9.5pt; color: #888">Page 2</span>
      </header>

      <!-- EXPERIENCE 続き -->
      <section>
        <h2
          style="
            display: block;
            font-size: 20px;
            font-weight: 700;
            letter-spacing: 1.5px;
            margin: 0 0 12px;
            text-transform: uppercase;
            text-align: left;
            color: #222;
            border-bottom: 2px solid #222;
            padding-bottom: 3px;
          "
        >
          EXPERIENCE (continued)
        </h2>
        <div
          :data-highlight="highlightMessage"
          @click="goCardTo('job-history')"
          :class="highLightClass('job-history')"
        >
          <template v-for="job in jobsPage2">
            <div
              v-for="(project, pIndex) in job.projects && job.projects.length
                ? job.projects
                : [null]"
              :key="job.uuid + '-p2-' + pIndex"
              style="margin-bottom: 10px"
            >
              <h3
                v-if="project && project.projectTitle"
                style="
                  display: block;
                  font-size: 11pt;
                  font-weight: 700;
                  color: #222;
                  text-align: left;
                  margin: 0;
                "
              >
                {{ project.projectTitle }}
              </h3>
              <h3
                v-else-if="pIndex === 0 && job.companyName"
                style="
                  display: block;
                  font-size: 11pt;
                  font-weight: 700;
                  color: #222;
                  text-align: left;
                  margin: 0;
                "
              >
                {{ job.companyName }}
              </h3>
              <p style="margin: 0; font-size: 9.5pt; color: #555">
                {{ formatExperiencePeriod(job, project) }}
              </p>
              <p
                v-if="job.companyName"
                style="margin: 0 0 2px; font-style: italic"
              >
                {{ job.companyName }}
              </p>
              <pre
                v-if="project && project.contentsOfProject"
                style="
                  font-family: inherit;
                  white-space: pre-wrap;
                  overflow-wrap: break-word;
                  margin: 0;
                  font-size: 10pt;
                  line-height: 1.5;
                "
                >{{ project.contentsOfProject }}</pre>
              <pre
                v-else-if="!project && job.businessArea"
                style="
                  font-family: inherit;
                  white-space: pre-wrap;
                  overflow-wrap: break-word;
                  margin: 0;
                  font-size: 10pt;
                  line-height: 1.5;
                "
                >{{ job.businessArea }}</pre>
            </div>
          </template>
        </div>
      </section>
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  formatExperiencePeriod,
  previewHighLightClass
} from '@/utils/format-edit/englishResumePreview'

const props = withDefaults(
  defineProps<{
    jobsPage2: any[]
    fullName: string
    highlightMessage: string
    currentCardId?: string | string[]
    idPrefix?: string
    isSample?: boolean
    cardChanged?: boolean
  }>(),
  {
    currentCardId: '',
    idPrefix: '',
    isSample: false,
    cardChanged: false
  }
)

const emit = defineEmits<{ (e: 'go-card-to', id: string): void }>()

function goCardTo(id: string) {
  emit('go-card-to', id)
}

function highLightClass(cardId: string | string[]) {
  return previewHighLightClass(
    cardId,
    props.currentCardId,
    !!props.cardChanged,
    !!props.isSample
  )
}
</script>
